var api = require("!../../../../../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../../../css-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../../../sass-loader/dist/cjs.js!../../../../../../../semi-webpack-plugin/lib/semi-theme-loader?{\"name\":\"@semi-bot/semi-theme-biogeometry\",\"variables\":\"\"}!./tag.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};